import { render, staticRenderFns } from "./CarManage.vue?vue&type=template&id=54ccaec6&scoped=true&"
import script from "./CarManage.vue?vue&type=script&lang=js&"
export * from "./CarManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ccaec6",
  null
  
)

export default component.exports